import { saveConfig, setIsMobile, setIsMenuMobileSelected } from './commonActions';
import {
    getMyAccountDashboardEspotPending,
    getMyAccountDashboardEspotSuccess,
    getMyAccountDashboardEspotError,
    getMyAccountReorderTopDashboardEspotPending,
    getMyAccountReorderTopDashboardEspotSuccess,
    getMyAccountReorderTopDashboardEspotError,
    getMyAccountTopDashboardEspotPending,
    getMyAccountTopDashboardEspotSuccess,
    getMyAccountTopDashboardEspotError,
    getMyAccountBottomDashboardEspotPending,
    getMyAccountBottomDashboardEspotSuccess,
    getMyAccountBottomDashboardEspotError,
    getDashboardInformationsPending,
    getDashboardInformationsSuccess,
    getDashboardInformationsError,
} from './dashboardActions';
import {
    getUserEyeExamsPending,
    getUserEyeExamsSuccess,
    getUserEyeExamsError,
    getDoctorInfoPending,
    getDoctorInfoSuccess,
    getDoctorInfoError,
    deleteEyeExamPending,
    deleteEyeExamSuccess,
    deleteEyeExamError,
    syncMyEyeExamsPending,
    syncMyEyeExamsSuccess,
    syncMyEyeExamsError,
    getAccessTokenPending,
    getAccessTokenSuccess,
    getAccessTokenError,
    addToCartPending,
    addToCartSuccess,
    addToCartError,
    removeMySavedPrescriptionSuccess,
    removeMySavedPrescriptionPending,
    removeMySavedPrescriptionError,
    getMySavedPrescriptionsPending,
    getMySavedPrescriptionsSuccess,
    getMySavedPrescriptionsError,
    setJustUpdateId,
    getClDetailsRightPending,
    getClDetailsRightSuccess,
    getClDetailsRightError,
    getClDetailsLeftPending,
    getClDetailsLeftSuccess,
    getClDetailsLeftError,
    getHowToReadEspotClSuccess,
    getHowToReadEspotClError,
    getHowToReadEspotClPending,
    setOpenModalAddDoctor,
    getDoctorSuccess,
    getDoctorError,
    getDoctorPending,
    getPDEspotSuccess,
    getPDEspotError,
    getPDEspotPending,
    getHowToReadEspotSuccess,
    getHowToReadEspotError,
    getHowToReadEspotPending,
} from './myAppointmentActions';
import {
    getEncryptedOnlineOrderIdPending,
    getEncryptedOnlineOrderIdSuccess,
    getEncryptedOnlineOrderIdError,
    getOnlineOrdersHistoryPending,
    getOnlineOrdersHistorySuccess,
    getOnlineOrdersHistoryError,
    getGlobalOrderDetailsPending,
    getGlobalOrderDetailsSuccess,
    getGlobalOrderDetailsError,
    getOrderItemCarrierUrlPending,
    getOrderItemCarrierUrlSuccess,
    getOrderItemCarrierUrlError,
    saveSearchFilters,
    getMyPurchasesPending,
    getMyPurchasesSuccess,
    getMyPurchasesError,
    getPrescriptionInfoDetails,
    getRetailOrderHistoryPending,
    getRetailOrderHistoryError,
    getRetailOrderHistorySuccess
} from './myPurchasesActions';

import {
    getPersonalDetailsPending,
    getPersonalDetailsSuccess,
    getPersonalDetailsError,
    getGeographicInformationsPending,
    getGeographicInformationsSuccess,
    getGeographicInformationsError,
    updatePersonalDetailsPending,
    updatePersonalDetailsSuccess,
    updatePersonalDetailsError,
    updateSettingsPasswordPending,
    updateSettingsPasswordSuccess,
    updateSettingsPasswordError,
    updateSettingsPasswordCustomError,
    getSettingsUserSettingsPending,
    getSettingsUserSettingsSuccess,
    getSettingsUserSettingsError,
    updatePersonalizationSettingsPending,
    updatePersonalizationSettingsSuccess,
    updatePersonalizationSettingsError,
    createSubscriptionPending,
    createSubscriptionSuccess,
    createSubscriptionError,
    deleteSubscriptionPending,
    deleteSubscriptionSuccess,
    deleteSubscriptionError,
    getFavouritesStoresPending,
    getFavouritesStoresSuccess,
    getFavouritesStoresError,
    removeFavouriteStorePending,
    removeFavouriteStoreSuccess,
    removeFavouriteStoreError,
    setDefaultStorePending,
    setDefaultStoreSuccess,
    setDefaultStoreError,
    addPaymentMethodPending,
    addPaymentMethodSuccess,
    addPaymentMethodError,
    editPaymentMethodPending,
    editPaymentMethodSuccess,
    editPaymentMethodError,
    getPaymentMethodsPending,
    getPaymentMethodsSuccess,
    getPaymentMethodsError,
    setDefaultPaymentMethodPending,
    setDefaultPaymentMethodSuccess,
    setDefaultPaymentMethodError,
    removePaymentMethodPending,
    removePaymentMethodSuccess,
    removePaymentMethodError,
    getMySavedItemsPending,
    getMySavedItemsSuccess,
    getMySavedItemsError,
    getAddressesPending,
    getAddressesSuccess,
    getAddressesError,
    addAddressPending,
    addAddressSuccess,
    addAddressError,
    editAddressPending,
    editAddressSuccess,
    editAddressError,
    setDefaultAddressPending,
    setDefaultAddressSuccess,
    setDefaultAddressError,
    deleteAddressPending,
    deleteAddressSuccess,
    deleteAddressError,
    getUserSubscriptionEmail,
    getUserSubscriptionPhone,
    getUserSubscriptionEmailChanged,
    getUserSubscriptionPhoneChanged,
    getUserSubscriptionCorrect
} from './myProfileActions';

export {
    //COMMONS ACTIONS
    saveConfig,
    setIsMobile,
    setIsMenuMobileSelected,
    // DASHBOARD ACTIONS
    getMyAccountDashboardEspotPending,
    getMyAccountDashboardEspotSuccess,
    getMyAccountDashboardEspotError,
    getMyAccountReorderTopDashboardEspotPending,
    getMyAccountReorderTopDashboardEspotSuccess,
    getMyAccountReorderTopDashboardEspotError,
    getMyAccountTopDashboardEspotPending,
    getMyAccountTopDashboardEspotSuccess,
    getMyAccountTopDashboardEspotError,
    getMyAccountBottomDashboardEspotPending,
    getMyAccountBottomDashboardEspotSuccess,
    getMyAccountBottomDashboardEspotError,
    getDashboardInformationsPending,
    getDashboardInformationsSuccess,
    getDashboardInformationsError,
    //MY APPOINTMENT ACTIONS
    getUserEyeExamsPending,
    getUserEyeExamsSuccess,
    getUserEyeExamsError,
    getDoctorInfoPending,
    getDoctorInfoSuccess,
    getDoctorInfoError,
    deleteEyeExamPending,
    deleteEyeExamSuccess,
    deleteEyeExamError,
    syncMyEyeExamsPending,
    syncMyEyeExamsSuccess,
    syncMyEyeExamsError,
    getAccessTokenPending,
    getAccessTokenSuccess,
    getAccessTokenError,
    //MY PURCHASES ACTIONS
    getEncryptedOnlineOrderIdPending,
    getEncryptedOnlineOrderIdSuccess,
    getEncryptedOnlineOrderIdError,
    getOnlineOrdersHistoryPending,
    getOnlineOrdersHistorySuccess,
    getOnlineOrdersHistoryError,
    getGlobalOrderDetailsPending,
    getGlobalOrderDetailsSuccess,
    getGlobalOrderDetailsError,
    getOrderItemCarrierUrlPending,
    getOrderItemCarrierUrlSuccess,
    getOrderItemCarrierUrlError,
    saveSearchFilters,
    getMyPurchasesPending,
    getMyPurchasesSuccess,
    getMyPurchasesError,
    getPrescriptionInfoDetails,
    getRetailOrderHistoryPending,
    getRetailOrderHistoryError,
    getRetailOrderHistorySuccess,
    //PERSONAL DETAILS
    getPersonalDetailsPending,
    getPersonalDetailsSuccess,
    getPersonalDetailsError,
    getGeographicInformationsPending,
    getGeographicInformationsSuccess,
    getGeographicInformationsError,
    updatePersonalDetailsPending,
    updatePersonalDetailsSuccess,
    updatePersonalDetailsError,
    //SETTINGS
    updateSettingsPasswordPending,
    updateSettingsPasswordSuccess,
    updateSettingsPasswordError,
    updateSettingsPasswordCustomError,
    getSettingsUserSettingsPending,
    getSettingsUserSettingsSuccess,
    getSettingsUserSettingsError,
    updatePersonalizationSettingsPending,
    updatePersonalizationSettingsSuccess,
    updatePersonalizationSettingsError,
    createSubscriptionPending,
    createSubscriptionSuccess,
    createSubscriptionError,
    deleteSubscriptionPending,
    deleteSubscriptionSuccess,
    deleteSubscriptionError,
    //MY STORES
    getFavouritesStoresPending,
    getFavouritesStoresSuccess,
    getFavouritesStoresError,
    removeFavouriteStorePending,
    removeFavouriteStoreSuccess,
    removeFavouriteStoreError,
    setDefaultStorePending,
    setDefaultStoreSuccess,
    setDefaultStoreError,
    //PAYMENT METHODS
    addPaymentMethodPending,
    addPaymentMethodSuccess,
    addPaymentMethodError,
    editPaymentMethodPending,
    editPaymentMethodSuccess,
    editPaymentMethodError,
    getPaymentMethodsPending,
    getPaymentMethodsSuccess,
    getPaymentMethodsError,
    setDefaultPaymentMethodPending,
    setDefaultPaymentMethodSuccess,
    setDefaultPaymentMethodError,
    removePaymentMethodPending,
    removePaymentMethodSuccess,
    removePaymentMethodError,
    getMySavedItemsPending,
    getMySavedItemsSuccess,
    getMySavedItemsError,
    // ADDRESSES
    getAddressesPending,
    getAddressesSuccess,
    getAddressesError,
    addAddressPending,
    addAddressSuccess,
    addAddressError,
    editAddressPending,
    editAddressSuccess,
    editAddressError,
    setDefaultAddressPending,
    setDefaultAddressSuccess,
    setDefaultAddressError,
    deleteAddressPending,
    deleteAddressSuccess,
    deleteAddressError,
    getUserSubscriptionEmail,
    getUserSubscriptionPhone,
    getUserSubscriptionEmailChanged,
    getUserSubscriptionPhoneChanged,
    getUserSubscriptionCorrect,
    //ADD TO BAG
    addToCartPending,
    addToCartSuccess,
    addToCartError,
    removeMySavedPrescriptionSuccess,
    removeMySavedPrescriptionPending,
    removeMySavedPrescriptionError,
    getMySavedPrescriptionsPending,
    getMySavedPrescriptionsSuccess,
    getMySavedPrescriptionsError,
    setJustUpdateId,
    getClDetailsRightPending,
    getClDetailsRightSuccess,
    getClDetailsRightError,
    getClDetailsLeftPending,
    getClDetailsLeftSuccess,
    getClDetailsLeftError,
    getHowToReadEspotClSuccess,
    getHowToReadEspotClError,
    getHowToReadEspotClPending,
    setOpenModalAddDoctor,
    getDoctorSuccess,
    getDoctorError,
    getDoctorPending,
    getPDEspotSuccess,
    getPDEspotError,
    getPDEspotPending,
    getHowToReadEspotSuccess,
    getHowToReadEspotError,
    getHowToReadEspotPending,
};
